/**
 * 결재함 진입점 상수 — 결재함에서 연 보고서 상세의 back-link으로 전파한다.
 *
 * 상세는 `location.state.{from,fromLabel}`를 back-link으로 쓴다
 * (`components/reports/manifest/detailBackNav.ts`). 전파하지 않으면 상세가 type 기본값
 * (문서관리 목록)으로 폴백해, 결재함에서 들어왔는데 뒤로가기가 `/reports`로 샌다.
 */

/** App.tsx의 결재함 라우트 경로. */
export const APPROVALS_PATH = '/approvals';

/** 뒤로가기 라벨 — Layout 사이드바 메뉴 라벨과 일치시킨다. */
export const APPROVALS_LABEL = '결재함';
